import { gql } from '@apollo/client'

export const getPageMetrics = gql`
  query GetPageMetrics {
    getPageMetrics
  }
`
